import { render, staticRenderFns } from "./zykPlayer2.vue?vue&type=template&id=43a5b481&scoped=true"
import script from "./zykPlayer2.vue?vue&type=script&lang=js"
export * from "./zykPlayer2.vue?vue&type=script&lang=js"
import style0 from "./zykPlayer2.vue?vue&type=style&index=0&id=43a5b481&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a5b481",
  null
  
)

export default component.exports